import React, { useEffect, useState, useCallback } from "react";
import { useDropzone } from 'react-dropzone'
const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

function TSUpload2(props) {

    const [files, setFiles] = useState([]);

    async function uploadWithJSON(file) {
        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
        //console.log(file)

        const data = {
            title: file.name,
            size: file.size,
            type: file.type,
            file: await toBase64(file),
        }

        return await data;
    }
  
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => 
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ));
            if (props.onDrop) {
                console.log(files);
                props.onDrop(files);
            }
          
        },
        onChange: e => {
            if (props.onChange) {
                console.log(e.target.files)
                props.onChange(e.target.files);
            }
        }
    });


  
    /*
    const onDrop = useCallback((acceptedFiles) => {
        Promise.resolve(
           

            acceptedFiles.map(file =>
                setFiles(
                        uploadWithJSON(file)

                )

            )
         ).then((e) => console.log(e))
    })

    const { getRootProps, getInputProps } = useDropzone({ onDrop })
    */


    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                />
            </div>
        </div>
    ));
  

    /*
    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);
    */
    return (
        <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
                <input name={props.name} {...getInputProps()} /*onChange={handleChange}*/ />
                <p> <i className="now-ui-icons design_image"></i> {props.msg}</p>
            </div>
            <aside style={thumbsContainer}>
                {thumbs}
            </aside>
        </section>
    )
}

export default TSUpload2;